import React, { useState } from 'react';

const TimesheetFAQAccordion = () => {
  const [openItem, setOpenItem] = useState(null);
  
  const faqItems = [
    { id: 1, question: "How do I submit my timesheet?", answer: "To submit your timesheet, navigate to the Timesheets section, complete all required fields, and click the Submit button." },
    { id: 2, question: "Can I edit my timesheet after submission?", answer: "Yes, you can edit a submitted timesheet before the approval deadline. Go to your timesheet history, find the entry, and click Edit." },
    { id: 3, question: "What if I forget to submit my timesheet?", answer: "If you miss the deadline, contact your supervisor who can authorize a late submission. You'll need to provide a reason for the delay." },
    { id: 4, question: "How can I view my past timesheets?", answer: "Access your timesheet history by clicking on the 'History' tab in the Timesheets section. You can filter by date range and project." },
    { id: 5, question: "Can I submit timesheets for multiple projects?", answer: "Yes, you can add multiple projects to a single timesheet. Use the 'Add Project' button to include additional projects and allocate hours accordingly." },
    { id: 6, question: "How do I add a new project to my timesheet?", answer: "Click the 'Add Project' button while editing your timesheet. Select the project from the dropdown menu and allocate hours." },
    { id: 7, question: "What if I need to correct an error on my timesheet?", answer: "For corrections after approval, submit a correction request through the system. For pending timesheets, you can edit directly." },
    { id: 8, question: "How do I track my overtime hours?", answer: "Use the dedicated Overtime section in your timesheet. Select the overtime category and enter the additional hours worked." },
    { id: 9, question: "Can I access my timesheet from my mobile device?", answer: "Yes, our timesheet system is mobile-responsive. You can also download our mobile app for easier access on the go." },
    { id: 10, question: "Who can I contact for technical support?", answer: "For technical issues, contact the IT Help Desk at support@company.com or call extension 1234 during business hours." }
  ];

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  // CSS styles
  const styles = {
    container: {
      width: '100%',
      maxWidth: '1000px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
    },
    item: {
      borderBottom: '1px solid #e2e8f0',
      borderTop: 'none',
    },
    firstItem: {
      borderTop: '1px solid #e2e8f0',
    },
    button: {
      width: '100%',
      padding: '15px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'left',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      outline: 'none',
    },
    questionContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    number: {
      color: '#2cb1bc',
      fontWeight: '500',
      marginRight: '8px',
      fontSize: '15px',
    },
    question: {
      color: '#2cb1bc',
      fontSize: '15px',
      fontWeight: 'normal',
    },
    arrow: {
      width: '16px',
      height: '16px',
      color: '#2cb1bc',
      transition: 'transform 0.2s ease',
    },
    arrowOpen: {
      transform: 'rotate(180deg)',
    },
    content: {
      padding: '0 20px 15px 20px',
      color: '#4a5568',
      fontSize: '14px',
      lineHeight: '1.5',
    }
  };

  return (
    <div style={styles.container}>
      {faqItems.map((item, index) => (
        <div key={item.id} style={{...styles.item, ...(index === 0 ? styles.firstItem : {})}}>
          <button 
            style={styles.button}
            onClick={() => toggleItem(item.id)}
          >
            <div style={styles.questionContainer}>
              <span style={styles.question}>
                {item.question}
              </span>
            </div>
            <svg 
              style={{...styles.arrow, ...(openItem === item.id ? styles.arrowOpen : {})}}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {openItem === item.id && (
            <div style={styles.content}>
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TimesheetFAQAccordion;